var _defs, _path, _path2, _path3, _path4, _tspan;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDayCalendarColored(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .dclc1,.dclc2{fill:none;stroke:#8c8d99;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}.dclc2{fill:#1bc47d;stroke:#1bc47d}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_calendar",
    "data-name": "vuesax/linear/calendar",
    transform: "translate(-300 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    className: "dclc1",
    d: "M13 0c3.33.18 5 1.45 5 6.15v6.18c0 4.12-1 6.18-6 6.18H6c-5 0-6-2.06-6-6.18V6.15C0 1.45 1.67.19 5 0z",
    transform: "translate(303 255.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    className: "dclc1",
    d: "M17.5 0H0",
    transform: "translate(303.25 269.6)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    className: "dclc2",
    d: "M0 0v3",
    transform: "translate(308 254)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    className: "dclc2",
    d: "M0 0v3",
    transform: "translate(316 254)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_8",
    "data-name": 8,
    transform: "translate(316 267)",
    style: {
      fontSize: 12,
      fontFamily: "Vazir-Black-FD,Vazir FD",
      fill: "#1bc47d"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u06F8"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDayCalendarColored);
export default __webpack_public_path__ + "static/media/day-calendar-colored.78df8d5aff6020890ff71ed7b09b2864.svg";
export { ForwardRef as ReactComponent };